<h2 *ngIf="data.title" mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content *ngIf="data.content">
  <p>{{data.content}}</p>
</mat-dialog-content>
<mat-dialog-actions [attr.align]="data.spacedActions ? null : 'end'" [ngClass]="{'confirm-actions': data.spacedActions}">
  <button *ngIf="data.textButtonOne" id="buttonOne" mat-raised-button (click)="buttonOneClicked()">{{data.textButtonOne}}</button>
  <button *ngIf="data.textButtonTwo" id="buttonTwo" mat-raised-button (click)="buttonTwoClicked()" color="accent">{{data.textButtonTwo}}</button>
</mat-dialog-actions>
